import uuid from 'uuid-random';

// TODO need removed this file after Core Merge 24.7.4.0

export const GAMES_INFO_POPUP_ID = uuid();
